import React, { useState } from "react";
import Layout from "./layout.js";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DateInput from "../components/DateInput.js";
import Button from "../components/Button.js";
import Col from "react-bootstrap/Col";
import SearchBar from "../components/Searchbar.js";
import Filter from "../components/Filter";
import SortTable from "../components/SortTable"; // Import SortTable
import KeywordPerformance from "../components/KeywordPerformance.js";
import BlacklinkData from "../components/BlacklinkData.js";
import EmailMetrics from "../components/EmailMetric.js";
import SearchQuery from "../components/SearchQueries.js";
import TopEntryPage from "../components/TopEntryPage.js";


const SearchEngine = () => {

    const navigate = useNavigate();
    const filterable = true;
    const grid = true;
    const sortable = true;

    const [data, setData] = useState([
        { name: "Campaign 1", clicks: 100 },
        { name: "Campaign 2", clicks: 200 },
        { name: "Campaign 3", clicks: 150 },
    ]);

    const [columns] = useState([
        { label: "Name", accessor: "name" },
        { label: "Clicks", accessor: "clicks" }
    ]);

    const [filteredData, setFilteredData] = useState(data);
    const [searchable] = useState(true); // assuming you want it always true
    const [id] = useState("campaign-table"); // replace with real ID if needed
    const [sortColumn, setSortColumn] = useState("name");
    const [sortOrder, setSortOrder] = useState("asc");

    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };
    const handleViewToggle = () => {
        console.log("View toggled");
    };

    // Handle search query
    const handleSearch = (query) => {
        // Apply search filter on existing data (combined with any existing filter)
        const searchedData = data.filter((item) => {
            return Object.values(item).some((value) =>
                String(value).toLowerCase().includes(query.toLowerCase())
            );
        });
        setFilteredData(searchedData);
    };

    return (
        <Layout>
            <div className="d-flex align-items-center justify-content-between">
                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>
                <div className="text-right gap-3 ie-btn d-flex">
                    <Button
                        buttonType="^"
                        onClick={() => navigate("/add-usersegment")}
                        label="User Segment"
                    />
                </div>
            </div>
            <div>
                <Row className="align-items-center  mt-4">
                    <Col>
                        {searchable && (
                            <SearchBar
                                tableId={id}
                                gridviewId={id}
                                placeholder="Search for data..."
                                onSearch={(query) => handleSearch(query)}
                            />
                        )}
                    </Col>
                    <Col className="mt-2 col-auto">
                        <div className="d-flex justify-content-end gap-2">
                            {filterable && (
                                <Filter
                                    columns={columns}
                                    data={data}
                                    onFilter={setFilteredData} // Update filtered data
                                    tableId={id}
                                    gridviewId={id}
                                />
                            )}

                            {/* View Toggle Button */}
                            {grid && (
                                <div className="table-btn">
                                    <button className="btn grid-btn " onClick={handleViewToggle}>
                                        <i className="bi bi-grid"></i>
                                    </button>
                                </div>
                            )}

                            {sortable && (
                                <SortTable
                                    data={filteredData}
                                    setSortedData={setFilteredData}
                                    columns={columns}
                                    sortColumn={sortColumn}
                                    setSortColumn={setSortColumn}
                                    sortOrder={sortOrder}
                                    setSortOrder={setSortOrder}
                                />
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
            <div>
                <Row>
                    <Col md={7}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px",marginTop: "20px" }}>
                            <h3>Keywords Performance</h3>
                            <KeywordPerformance />
                        </div>
                    </Col>

                    <Col md={5}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px",marginTop: "20px" }}>
                            <h3>Blacklink Data</h3>
                            <BlacklinkData />
                        </div>
                    </Col>
                </Row>

            </div>
            <div>
                <Row>
                    <br></br>
                    <Col md={7}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Search Queries</h3>
                            <SearchQuery />
                        </div>

                    </Col>

                    <Col md={5}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Email Compaign Metrics</h3>
                            <EmailMetrics />
                        </div>
                    </Col>
                </Row>
            </div>
            <div>
                
               <TopEntryPage/>
            </div>
        </Layout>
    )
}

export default SearchEngine;